<template>
  <div>
    <div class="flex flex-col">
      <div class="flex flex-col items-center mb-6">
        <div class="px-4 mb-6">
          <img
            alt="..."
            class="shadow rounded max-w-full h-auto align-middle border-none"
            :src="!!avatar?avatar:imgPlaceholder"
            style="width: 150px;"
          />
        </div>
        <div class="flex flex-col mb-2">
          <p class="text-xs text-gray-700">Minimum 900x900, Maximum 1MB</p>
        </div>
        <div class="flex flex-col mb-2" v-if="isFileLarge || isErrorImage">
          <text-error v-if="isFileLarge" text="Please select correct file" />
          <text-error v-if="isErrorImage" text="Please select image cover" />
        </div>
        <div class="flex">
          <Button label="Browse File" v-if="!avatar">
            <template v-slot:any>
              <input style="width: 100%;height: 100%;position: absolute;left: 0;top: 0;opacity: 0;cursor: pointer;z-index: 2;"
                     type="file"
                     name="profile_picture"
                     @change="onFileChange"
              />
            </template>
          </Button>
          <Button label="Cancel" variant="default" v-if="avatar" @clicked="changeImage"></Button>
        </div>
      </div>
    </div>
    <form-item label='Full Name'>
      <template v-slot>
        <Input
          v-model="fullname"
          placeholder="Full Name"
          :error="($v.fullname.$dirty && (!$v.fullname.required || !$v.fullname.maxLength))"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.fullname.$dirty && !$v.fullname.required"
            text="Please fill your name."
          >
          </text-error>
          <text-error
            v-if="$v.fullname.$dirty && !$v.fullname.maxLength"
            text="Maximum character for name is 100 characters."
          >
          </text-error>
        </div>
      </template>
    </form-item>
    <form-item label='Email'>
      <template v-slot>
        <Input
          v-model="email"
          placeholder="Email"
          :error="($v.email.$dirty && isErrorEmail)"
        />
        <div class="flex flex-col pt-2">
          <text-error
            v-if="$v.email.$dirty && !$v.email.required"
            text="Please fill your email."
          >
          </text-error>
          <text-error
            v-if="$v.email.$dirty && !$v.email.maxLength"
            text="Maximum character for email is 100 characters."
          >
          </text-error>
          <text-error
            v-if="$v.email.$dirty && !$v.email.email"
            text="Please fill your correct email."
          >
          </text-error>
          <text-error
            v-if="emailErrorMessage.length > 0"
            :text="emailErrorMessage"
           />
        </div>
      </template>
    </form-item>
    <form-item label='Birthdate'>
      <template v-slot>
        <Input
          type="date"
          v-model="dob"
          placeholder="Birthdate"
        />
      </template>
    </form-item>
    <form-item label='Bio'>
      <template v-slot>
        <div class="relative" >
                <TextArea
                  v-model="bio"
                  placeholder="Tell us about you"
                  :error="$v.bio.$dirty && !$v.bio.maxLength"
                  :maxlength="bioMaxLength"
                  rows="10"
                />
          <div  class="absolute right-0 text-xs" style="bottom: 15px; right: 15px;" >{{bio.length}}/{{bioMaxLength}}</div>
        </div>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.bio.$dirty && !$v.bio.maxLength" text="Maximum character for bio is 2000 characters." />
        </div>
      </template>
    </form-item>
    <form-item label='Language'>
      <template v-slot>
        <el-select v-model="language" filterable placeholder="Select Language" class="w-full">
          <el-option
            v-for="item in dataLanguages"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <div class="flex flex-col pt-2">
          <text-error v-if="$v.language.$dirty && !$v.language.required" text="Please choose language." />
        </div>
      </template>
    </form-item>
    <form-item label='Password'>
      <template v-slot>
        <div class="relative">
          <Input
            :type="showPassword?'text':'password'"
            v-model="password"
            placeholder="Password"
          />
          <a class="absolute top-0 right-0 mr-2 mt-3 " @click="showPassword=!showPassword" style="cursor:pointer">
            <i class="fa" :class="showPassword?'fa-eye-slash':'fa-eye'"></i>
          </a>
        </div>
      </template>
    </form-item>
    <form-item label='Upload File Agreement'>
      <template v-slot>
        <div class="flex-1" >
          <input
            v-if="!fileAgreement"
            type="file"
            class="block border border-grey-light w-full p-3 rounded"
            name="file_agreement"
            @change="onFileChangeAgreement"
            accept="application/pdf"
          />
          <div v-if="fileAgreement" class="flex" >
            <span class="mr-2 text-gray-700 font-medium">{{fileAgreementName}}</span>
            <a @click="changeFileAgreement" class="cursor-pointer"><font-awesome-icon :icon="['fas', 'times-circle']"   /></a>
          </div>
        </div>
      </template>
    </form-item>
  </div>

</template>

<script>
import { validationMixin } from 'vuelidate';
import helpersMixin from '../../mixins/helpers.mixins';
import { required, email, maxLength } from 'vuelidate/lib/validators';
import { Button, FormItem, Input, Select, TextArea, TextError } from '@/components/Layout/Form';
import imgPlaceholder from '@/assets/image-placeholder.jpeg';

export default {
  name: 'Step1',
  mixins: [validationMixin, helpersMixin],
  data: () => ({
    dataLanguages: [],
    bioMaxLength: 2000,
    fullname: '',
    email: '',
    avatar: null,
    bio: '',
    dob: '',
    language: '',
    password: '',
    fileAgreement: null,
    fileAgreementName: null,
    emailErrorMessage: '',
    imageErrorMessage: '',
    isFileLarge: false,
    showPassword: false,
    imgPlaceholder,
  }),
  validations: {
    fullname: {
      required,
      maxLength: maxLength(100),
    },
    email: {
      required,
      isExists: false,
      email,
      maxLength: maxLength(100),
    },
    bio: {
      maxLength: maxLength(2000),
    },
    language: { required },
  },
  computed: {
    isErrorEmail() {
      return (this.$v.email.$dirty && !this.$v.email.required)
        || (this.$v.email.$dirty && !this.$v.email.email)
        || (this.$v.email.$dirty && !this.$v.email.maxLength)
        || (this.emailErrorMessage.length > 0);
    },
    isErrorImage() {
      return this.imageErrorMessage.length > 0;
    },
  },
  mounted() {
    this.dataLanguages = this.getLanguages();
  },
  methods: {
    validate() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid && this.imageErrorMessage.length === 0 && !this.isFileLarge;
      if (isValid) {
        this.isFileLarge = false;
      }
      this.$emit('on-validate', this.$data, isValid);
      return isValid;
    },
    onFileChange(e) {
      this.isFileLarge = false;
      this.imageErrorMessage = '';
      const file = e.target.files[0];
      if (file.size > 1024 * 1024) {
        this.$v.dirty = true;
        this.isFileLarge = true;
      }
      this.avatar = URL.createObjectURL(file);
    },
    changeImage() {
      this.avatar = null;
    },
    getExt(name) {
      const fileInfo = name.split('.');
      return fileInfo[fileInfo.length - 1];
    },
    onFileChangeAgreement(e) {
      const file = e.target.files[0];
      this.fileAgreement = this.getExt(file.name) == 'pdf' ? file : URL.createObjectURL(file);
      this.fileAgreementName = file.name;
    },
    changeFileAgreement() {
      this.fileAgreement = null;
    },
  },
  components:{
    FormItem,
    Input,
    TextArea,
    Button,
    TextError,
    Select,
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/Step1.vue